module.exports = __webpack_public_path__ + "img/IND-A-3-IV.1395155d.png";